import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

i18n
    .use(LanguageDetector) // Автоматически определяет язык браузера
    .use(initReactI18next) // Интеграция с React
    .init({
        resources: {
            "en": {
                "translation": {
                    "back": "Back",
                    "info": {
                        "banner": {
                            "title": "Premium Web Development",
                            "desc": "We build high-performance websites tailored to your business needs. From custom corporate portals to complex e-commerce platforms.",
                            "btn": "Start Your Project"
                        },
                        "portfolio": {
                            "title": "Project: Red Dragon",
                            "desc": "See our expertise in action. For the \"Red Dragon\" restaurant, we developed a complete digital ecosystem built on a robust backend architecture.",
                            "feature1_title": "Interactive Menu:",
                            "feature1_desc": "Dynamic categories, real-time availability.",
                            "feature2_title": "Smart Ordering System:",
                            "feature2_desc": "Seamless cart handling with distinct flows for delivery, takeaway, and dine-in.",
                            "feature3_title": "Admin Dashboard:",
                            "feature3_desc": "Easy management of orders, menu items, and pricing without writing code.",
                            "btn": "View Live Demo",
                            "btn_info": ""
                        },
                        "howItWorks": {
                            "title": "How we work",
                            "step1_title": "Leave a request",
                            "step1_desc": "Leave your contact information, and we will contact you to clarify all questions.",
                            "step2_title": "Fill out the form",
                            "step2_desc": "Answer the questions about your business to launch a website.",
                            "step3_title": "Get a ready-made website!",
                            "step3_desc": "We will help you choose a design, set up the logic, and connect payment systems."
                        },
                        "pricing": {
                            "title": "Website Pricing",
                            "subtitle": "Transparent pricing for different types of web projects.",
                            "th_type": "Type of Website",
                            "th_desc": "Description",
                            "th_time": "Timeline",
                            "th_price": "Starting Price",
                            "service1_title": "Frontend Development",
                            "service1_desc": "User interface development without backend logic. Ideal for presentation sites, business cards, and portfolios.",
                            "service1_time": "1-3 days",
                            "service1_price": "$50",
                            "service2_title": "Basic Website with Integration",
                            "service2_desc": "Fully functional website with basic server-side features, including contact forms and user registration.",
                            "service2_time": "3-7 days",
                            "service2_price": "$250",
                            "row1_title": "Landing Page",
                            "row1_desc": "Perfect for a single product, service, or promotional campaign. High conversion rate.",
                            "row1_time": "1-5 days",
                            "row2_title": "Corporate Website",
                            "row2_desc": "Multipage site for companies. Includes blog, services, and team sections.",
                            "row2_time": "1-2 weeks",
                            "row3_title": "Custom E-commerce / Web App",
                            "row3_desc": "Full online store or custom logic (like restaurant ordering systems) with admin panel.",
                            "row3_time": "3-4 weeks",
                            "price1": "$500",
                            "price2": "$1,200",
                            "price3": "$2,500"
                        },
                        "faq": {
                            "title": "Frequently asked questions",
                            "q1": "Do you provide the source code?",
                            "a1": "Yes, after full payment and project completion, all source code and intellectual property rights are transferred to you.",
                            "q2": "What payment methods are available?",
                            "a2": "We accept bank transfers, and cryptocurrency. Payments are typically split into milestones.",
                            "q3": "What level of tuning can you make?",
                            "a3": "Since we write custom code, we can implement any business logic, integrate third-party APIs, and build complex databases.",
                            "q4": "What is included in support and service?",
                            "a4": "We provide 1 month of free bug fixing and technical support after launch. Extended support plans are available."
                        },
                        "contact": {
                            "title": "Contact us and we will give you a consultation!",
                            "placeholder_name": "Name*",
                            "placeholder_email": "Contact info",
                            "placeholder_project": "Project or Company name",
                            "btn": "Submit your application"
                        }
                    },
                    "legal": {
                        "policy_link": "Privacy Policy",
                        "agreement_text": "By clicking the button, you agree to the Privacy Policy",
                        "footer_copy": "© 2026 Special Web Creation. All rights reserved.",
                        "full_policy": {
                            "title": "Privacy Policy",
                            "admin": "Personal data processing is carried out by the Site Administrator of specialwebcreation.com. For all inquiries, please contact specialwebcreation@gmail.com.",
                            "collection": "We collect names and contact information solely to communicate with clients regarding web development services.",
                            "storage": "Data is processed using beget.com infrastructure (RF) and is not shared with third parties.",
                            "consent": "By submitting any form on this site, you agree to this Policy."
                        }
                    }
                }
            },
            "ua": {
                "translation": {
                    "back": "Назад",
                    "welcome": "Ласкаво просимо на наш сайт!",
                    "description": "Ми не велика компанія, яка створює сайти на замовлення, розробляємо сайти будь-якого рівня складності персонально під клієнта.",

                    "info": {
                        "banner": {
                            "title": "Преміум веб-розробка",
                            "desc": "Ми створюємо високопродуктивні сайти, адаптовані під потреби вашого бізнесу. Від індивідуальних корпоративних порталів до складних платформ електронної комерції.",
                            "btn": "Почати проект"
                        },
                        "portfolio": {
                            "title": "Проєкт: Red Dragon",
                            "desc": "Подивіться на наш досвід у дії. Для ресторану «Red Dragon» ми розробили повноцінну цифрову екосистему, побудовану на надійній backend-архітектурі.",
                            "feature1_title": "Інтерактивне меню:",
                            "feature1_desc": "Динамічні категорії, доступність у реальному часі.",
                            "feature2_title": "Розумна система замовлень:",
                            "feature2_desc": "Безперебійна обробка кошика з окремими процесами для доставки, самовивозу та замовлень у закладі.",
                            "feature3_title": "Панель адміністратора:",
                            "feature3_desc": "Легке керування замовленнями, позиціями меню та цінами без написання коду.",
                            "btn": "Дивитися демо",
                            "btn_info": ""
                        },
                        "howItWorks": {
                            "title": "Як ми працюємо",
                            "step1_title": "Залиште заявку",
                            "step1_desc": "Залиште свої контактні дані, і ми зв'яжемося з вами для уточнення всіх питань.",
                            "step2_title": "Заповніть форму",
                            "step2_desc": "Дайте відповіді на запитання про ваш бізнес для запуску сайту.",
                            "step3_title": "Отримайте готовий сайт!",
                            "step3_desc": "Ми допоможемо вам вибрати дизайн, налаштувати логіку та підключити платіжні системи."
                        },
                        "pricing": {
                            "title": "Ціни на сайти",
                            "subtitle": "Прозоре ціноутворення для різних типів веб-проєктів.",
                            "th_type": "Тип сайту",
                            "th_desc": "Опис",
                            "th_time": "Терміни",
                            "th_price": "Початкова ціна",
                            "service1_title": "Frontend-розробка",
                            "service1_desc": "Розробка інтерфейсу без серверної логіки. Ідеально підходить для сайтів-візиток та портфоліо.",
                            "service1_time": "1-3 дні",
                            "service1_price": "$50",
                            "service2_title": "Базовий веб-сайт з інтеграцією",
                            "service2_desc": "Повноцінний сайт з базовим серверним функціоналом, включаючи форми зворотного зв'язку та системи реєстрації користувачів.",
                            "service2_time": "3-7 днів",
                            "service2_price": "$250",
                            "row1_title": "Лендінг (Landing Page)",
                            "row1_desc": "Ідеально підходить для одного продукту, послуги або рекламної кампанії. Висока конверсія.",
                            "row1_time": "1-5 днів",
                            "row2_title": "Корпоративний сайт",
                            "row2_desc": "Багатосторінковий сайт для компаній. Включає блог, послуги та розділи про команду.",
                            "row2_time": "1-2 тижні",
                            "row3_title": "Кастомний E-commerce / Веб-додаток",
                            "row3_desc": "Повноцінний інтернет-магазин або індивідуальна логіка (наприклад, системи замовлення для ресторанів) з панеллю адміністратора.",
                            "row3_time": "3-4 тижні",
                            "price1": "$500",
                            "price2": "$1,200",
                            "price3": "$2,500"
                        },
                        "faq": {
                            "title": "Часто задавані питання",
                            "q1": "Чи надаєте ви вихідний код?",
                            "a1": "Так, після повної оплати та завершення проєкту всі вихідні коди та права інтелектуальної власності переходять до вас.",
                            "q2": "Які способи оплати доступні?",
                            "a2": "Ми приймаємо банківські перекази, та криптовалюту. Оплата зазвичай розбивається на етапи.",
                            "q3": "Який рівень налаштування ви можете зробити?",
                            "a3": "Оскільки ми пишемо кастомний код, ми можемо реалізувати будь-яку бізнес-логіку, інтегрувати сторонні API та створювати складні бази даних.",
                            "q4": "Що входить до підтримки та обслуговування?",
                            "a4": "Ми надаємо 1 місяць безкоштовного виправлення багів та технічної підтримки після запуску. Доступні розширені плани підтримки."
                        },
                        "contact": {
                            "title": "Зв'яжіться з нами, і ми надамо вам консультацію!",
                            "placeholder_name": "Ім'я*",
                            "placeholder_email": "Контактна інформація",
                            "placeholder_project": "Назва проєкту або компанії",
                            "btn": "Залишити заявку"
                        }
                    },
                    "legal": {
                        "policy_link": "Політика конфіденційності",
                        "agreement_text": "Натискаючи кнопку, ви погоджуєтеся з Політикою конфіденційності",
                        "footer_copy": "© 2026 Special Web Creation. Усі права захищені.",
                        "full_policy": {
                            "title": "Політика конфіденційності",
                            "admin": "Обробка персональних даних здійснюється Адміністратором сайту specialwebcreation.com. З усіх питань звертайтеся на specialwebcreation@gmail.com.",
                            "collection": "Ми збираємо ім'я та контактну інформацію виключно для зв'язку з клієнтом з метою обговорення послуг зі створення сайту.",
                            "storage": "Дані обробляються на обладнанні провайдера beget.com та не передаються третім особам.",
                            "consent": "Надсилаючи форму на сайті, ви погоджуєтеся з цією Політикою."
                        }
                    }
                }
            },
            "ru": {
                "translation": {
                    "back": "Назад",
                    "welcome": "Добро пожаловать на наш сайт!",
                    "description": "Мы не большая компания создающая сайты на заказ, разрабатываем сайты любого уровня сложности персонально под клиента.",

                    "info": {
                        "banner": {
                            "title": "Премиум веб-разработка",
                            "desc": "Мы создаем высокопроизводительные сайты, адаптированные под нужды вашего бизнеса. От индивидуальных корпоративных порталов до сложных платформ электронной коммерции.",
                            "btn": "Начать проект",
                        },
                        "portfolio": {
                            "title": "Проект: Red Dragon",
                            "desc": "Посмотрите на наш опыт в действии. Для ресторана «Red Dragon» мы разработали полноценную цифровую экосистему, построенную на надежной backend-архитектуре.",
                            "feature1_title": "Интерактивное меню:",
                            "feature1_desc": "Динамические категории, доступность в реальном времени.",
                            "feature2_title": "Умная система заказов:",
                            "feature2_desc": "Бесперебойная обработка корзины с отдельными процессами для доставки, самовывоза и заказов в заведении.",
                            "feature3_title": "Панель администратора:",
                            "feature3_desc": "Легкое управление заказами, позициями меню и ценами без написания кода.",
                            "btn": "Смотреть пример",
                            "btn_info": "Если у вас не подгружается сайт, значит ркн блокирует его адрес, попробуйте зайти на сайт с VPN"
                        },
                        "howItWorks": {
                            "title": "Как мы работаем",
                            "step1_title": "Оставьте заявку",
                            "step1_desc": "Оставьте свои контактные данные, и мы свяжемся with вами для уточнения всех вопросов.",
                            "step2_title": "Заполните форму",
                            "step2_desc": "Ответьте на вопросы о вашем бизнесе для запуска сайта.",
                            "step3_title": "Получите готовый сайт!",
                            "step3_desc": "Мы поможем вам выбрать дизайн, настроить логику и подключить платежные системы."
                        },
                        "pricing": {
                            "title": "Цены на сайты",
                            "subtitle": "Прозрачное ценообразование для различных типов веб-проектов.",
                            "th_type": "Тип сайта",
                            "th_desc": "Описание",
                            "th_time": "Сроки",
                            "th_price": "Начальная цена",
                            "service1_title": "Frontend-разработка",
                            "service1_desc": "Разработка пользовательского интерфейса без сложной серверной логики. Идеально подходит для сайтов-визиток и портфолио.",
                            "service1_time": "1-3 дня",
                            "service1_price": "₽4,000",
                            "service2_title": "Базовый веб-сайт с интеграцией",
                            "service2_desc": "Полноценный сайт с базовым серверным функционалом, включая формы обратной связи и системы регистрации пользователей.",
                            "service2_time": "3-7 дней",
                            "service2_price": "₽20,000",
                            "row1_title": "Лендинг (Landing Page)",
                            "row1_desc": "Идеально подходит для одного продукта, услуги или рекламной кампании. Высокая конверсия.",
                            "row1_time": "1-5 дней",
                            "row2_title": "Корпоративный сайт",
                            "row2_desc": "Многостраничный сайт для компаний. Включает блог, услуги и разделы о команде.",
                            "row2_time": "1-2 недели",
                            "row3_title": "Кастомный E-commerce / Веб-приложение",
                            "row3_desc": "Полноценный интернет-магазин или индивидуальная логика (например, системы заказа для ресторанов) с панелью администратора.",
                            "row3_time": "3-4 недели",
                            "price1": "₽40,000",
                            "price2": "₽100,000",
                            "price3": "₽200,000"
                        },
                        "faq": {
                            "title": "Часто задаваемые вопросы",
                            "q1": "Предоставляете ли вы исходный код?",
                            "a1": "Да, после полной оплаты и завершения проекта все исходные коды и права интеллектуальной собственности переходят к вам.",
                            "q2": "Какие способы оплаты доступны?",
                            "a2": "Мы принимаем банковские переводы. Оплата разбивается на этапы.",
                            "q3": "Какой уровень настройки вы можете сделать?",
                            "a3": "Поскольку мы пишем кастомный код, мы можем реализовать любую бизнес-логику, интегрировать сторонние API и создавать сложные базы данных.",
                            "q4": "Что входит в поддержку и обслуживание?",
                            "a4": "Мы предоставляем 1 месяц бесплатного исправления багов и технической поддержки после запуска. Доступны расширенные планы поддержки."
                        },
                        "contact": {
                            "title": "Свяжитесь с нами, и мы предоставим вам консультацию!",
                            "placeholder_name": "Имя*",
                            "placeholder_email": "Контактная информация",
                            "placeholder_project": "Название проекта или компании",
                            "btn": "Оставить заявку"
                        }
                    },
                    "legal": {
                        "policy_link": "Политика конфиденциальности",
                        "agreement_text": "Нажимая кнопку, вы соглашаетесь с Политикой конфиденциальности",
                        "footer_copy": "© 2026 Special Web Creation. Все права защищены.",
                        "full_policy": {
                            "title": "Политика конфиденциальности",
                            "admin": "Обработка персональных данных осуществляется Администратором сайта specialwebcreation.com. По всем вопросам обращаться на specialwebcreation@gmail.com.",
                            "collection": "Мы собираем имя и контактную информацию исключительно для связи с клиентом в целях обсуждения услуг по созданию сайта.",
                            "storage": "Данные обрабатываются на оборудовании провайдера beget.com (РФ) и не передаются третьим лицам.",
                            "consent": "Отправляя форму на сайте, вы соглашаетесь с данной Политикой."
                        }
                    }
                }
            },
            "es": {
                "translation": {
                    "back": "Atrás",
                    "welcome": "¡Bienvenido a nuestro sitio web!",
                    "description": "Somos una pequeña empresa que crea sitios web personalizados. Desarrollamos sitios web de cualquier nivel de complejidad, adaptados a las necesidades del cliente.",

                    "info": {
                        "banner": {
                            "title": "Desarrollo Web Premium",
                            "desc": "Construimos sitios web de alto rendimiento adaptados a las necesidades de su negocio. Desde portales corporativos personalizados hasta complejas plataformas de comercio electrónico.",
                            "btn": "Iniciar Proyecto"
                        },
                        "portfolio": {
                            "title": "Proyecto: Red Dragon",
                            "desc": "Vea nuestra experiencia en acción. Para el restaurante \"Red Dragon\", desarrollamos un ecosistema digital completo construido sobre una sólida arquitectura de backend.",
                            "feature1_title": "Menú Interactivo:",
                            "feature1_desc": "Categorías dinámicas, disponibilidad en tiempo real.",
                            "feature2_title": "Sistema de Pedidos Inteligente:",
                            "feature2_desc": "Manejo perfecto del carrito con flujos distintos para entrega, para llevar y para comer en el lugar.",
                            "feature3_title": "Panel de Administración:",
                            "feature3_desc": "Fácil gestión de pedidos, elementos del menú y precios sin necesidad de escribir código.",
                            "btn": "Ver Demo en Vivo",
                            "btn_info": ""
                        },
                        "howItWorks": {
                            "title": "Cómo trabajamos",
                            "step1_title": "Deja una solicitud",
                            "step1_desc": "Deja tu información de contacto y nos pondremos en contacto contigo para aclarar todas las dudas.",
                            "step2_title": "Completa el formulario",
                            "step2_desc": "Responde a las preguntas sobre tu negocio para lanzar un sitio web.",
                            "step3_title": "¡Obtén un sitio web listo!",
                            "step3_desc": "Te ayudaremos a elegir un diseño, configurar la lógica y conectar sistemas de pago."
                        },
                        "pricing": {
                            "title": "Precios de Sitios Web",
                            "subtitle": "Precios transparentes para diferentes tipos de proyectos web.",
                            "th_type": "Tipo de Sitio Web",
                            "th_desc": "Descripción",
                            "th_time": "Plazos",
                            "th_price": "Precio Inicial",
                            "service1_title": "Desarrollo Frontend",
                            "service1_desc": "Desarrollo de interfaz de usuario sin lógica de servidor compleja. Perfecto para sitios de presentación y portafolios.",
                            "service1_time": "1-3 días",
                            "service1_price": "$50",
                            "service2_title": "Sitio Web Básico con Integración",
                            "service2_desc": "Un sitio web completamente funcional con características básicas de backend, incluyendo formularios de contacto y registro de usuarios.",
                            "service2_time": "3-7 días",
                            "service2_price": "$250",
                            "row1_title": "Landing Page",
                            "row1_desc": "Perfecto para un solo producto, servicio o campaña promocional. Alta tasa de conversión.",
                            "row1_time": "1-5 días",
                            "row2_title": "Sitio Web Corporativo",
                            "row2_desc": "Sitio multipágina para empresas. Incluye blog, servicios y secciones de equipo.",
                            "row2_time": "1-2 semanas",
                            "row3_title": "E-commerce Personalizado / App Web",
                            "row3_desc": "Tienda online completa o lógica personalizada (como sistemas de pedidos para restaurantes) con panel de administración.",
                            "row3_time": "3-4 semanas"
                        },
                        "faq": {
                            "title": "Preguntas frecuentes",
                            "q1": "¿Proporcionan el código fuente?",
                            "a1": "Sí, después del pago total y la finalización del proyecto, todos los derechos de propiedad intelectual y el código fuente se transfieren a usted.",
                            "q2": "¿Qué métodos de pago están disponibles?",
                            "a2": "Aceptamos transferencias bancarias, y criptomonedas. Los pagos suelen dividirse en etapas.",
                            "q3": "¿Qué nivel de personalización pueden hacer?",
                            "a3": "Dado que escribimos código personalizado, podemos implementar cualquier lógica de negocio, integrar API de terceros y construir bases de datos complejas.",
                            "q4": "¿Qué incluye el soporte y servicio?",
                            "a4": "Ofrecemos 1 mes de corrección de errores y soporte técnico gratuito después del lanzamiento. Hay planes de soporte extendido disponibles."
                        },
                        "contact": {
                            "title": "¡Contáctanos y te daremos una consulta!",
                            "placeholder_name": "Nombre*",
                            "placeholder_email": "Información de contacto",
                            "placeholder_project": "Nombre del proyecto o empresa",
                            "btn": "Enviar solicitud"
                        }
                    },
                    "legal": {
                        "policy_link": "Política de Privacidad",
                        "agreement_text": "Al hacer clic en el botón, usted acepta la Política de Privacidad",
                        "footer_copy": "© 2026 Special Web Creation. Todos los derechos reservados.",
                        "full_policy": {
                            "title": "Política de Privacidad",
                            "admin": "El tratamiento de los datos personales es realizado por el Administrador del sitio specialwebcreation.com. Para cualquier consulta, contacte a specialwebcreation@gmail.com.",
                            "collection": "Recopilamos nombres e información de contacto únicamente para comunicarnos con el cliente y discutir servicios de desarrollo web.",
                            "storage": "Los datos se procesan en la infraestructura de beget.com y no se comparten con terceros.",
                            "consent": "Al enviar cualquier formulario en este sitio, usted acepta esta Política."
                        }
                    }
                }
            }
        },
        fallbackLng: "en", // Язык по умолчанию, если перевод не найден
        interpolation: {
            escapeValue: false // React сам защищает от XSS
        }
    });

export default i18n;